import {Directive, ElementRef, AfterViewChecked, Input, NgModule} from '@angular/core';

@Directive({
    selector: '[filterMenu]',
    standalone: false
})
export class FilterMenuDirective implements AfterViewChecked {
    // class name to match height
    @Input()
    filterMenu: string;

    constructor(private el: ElementRef) {
    }

    ngAfterViewChecked() {
        this.filter(this.el.nativeElement, this.filterMenu);
    }
    filter(parent: HTMLElement, className: string) {
        // match height logic here
        if (!parent) return;
        // step 1: find all the child elements with the selected class name
        const children = parent.getElementsByClassName(className);
        if (!children) return;

        Array.from(children)
            .forEach((x: HTMLElement) => {
                if(/\(0\)\s+/g.test(x.getElementsByTagName("span")[0].innerText)) {
                    x.parentElement.style.display = "none"
                } else {
                    x.parentElement.style.display = "list-item"
                }
            });
    }
}

@NgModule({
    declarations: [FilterMenuDirective],
    exports: [FilterMenuDirective]
})
export class FilterMenuDirectiveModule {}
